import { EOccurrenceStatus } from '../../shared/enums/ocurrenceStatus';
import { api } from '../index';

export function createOccurrences(token: string, { id, ...dados }: any) {
  return api.post(`/occurrences`, dados, {
    headers: { Authorization: `Bearer ${token}` }
  });
}

export function editOccurrences(
  token: string,
  id: string | undefined,
  dados: any
) {
  return api.put(`/occurrences/${id}`, dados, {
    headers: { Authorization: `Bearer ${token}` }
  });
}

export function editStatusOccurrenceById({
  token,
  id,
  status
}: {
  token: string;
  id: string;
  status: EOccurrenceStatus;
}) {
  return api.put(
    `/occurrences/update-status/${id}`,
    { status: status },
    {
      headers: { Authorization: `Bearer ${token}` }
    }
  );
}

export async function deleteOccurrences(token: string, id: string) {
  try {
    const resposta = await api.delete(`/occurrences/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    let resp = resposta.data;
    return resp;
  } catch (erro) {
    console.warn('(Ocorrencias) Erro:', erro);
    return null;
  }
}

export async function getOccurrences(token: string, page?: number) {
  let params = new URLSearchParams();
  params.append('page', page != undefined ? page?.toString() : '0');
  params.append('order', 'DESC');

  try {
    const resposta = await api.get('/occurrences/v2', {
      headers: { Authorization: `Bearer ${token}` },
      params: params
    });
    let resp = resposta.data;
    return resp;
  } catch (erro) {
    console.warn('(Ocorrencias) Erro:', erro);
    return null;
  }
}

export async function getOccurrencesById(token: string, id: string) {
  try {
    const resposta = await api.get(`/occurrences/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    let resp = resposta.data;
    return resp;
  } catch (erro) {
    console.warn('(Ocorrencias) Erro:', erro);
    return null;
  }
}

type orderType = { value: 'ASC' | 'DESC' };
export type OccurrenceChangesOrder = 'ASC' | 'DESC';
export type OccurrenceChangeType =
  | 'create'
  | 'update'
  | 'delete'
  | 'approve'
  | 'disapprove'
  | 'unapprove';

export interface IOccurrenceChangeDiffItem {
  path: string;
  before: unknown;
  after: unknown;
}

export interface IOccurrenceChange {
  id: string;
  occurrenceId: string;
  userId?: string | null;
  user?: {
    id?: string;
    name?: string;
    nickname?: string;
  } | null;
  change_type: OccurrenceChangeType;
  snapshot_before?: Record<string, unknown> | null;
  snapshot_after?: Record<string, unknown> | null;
  diff: IOccurrenceChangeDiffItem[];
  createdAt: string;
}

export interface IOccurrenceChangesMeta {
  page: number;
  take: number;
  itemCount: number;
  pageCount: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export interface IOccurrenceChangesResponse {
  data: IOccurrenceChange[];
  meta: IOccurrenceChangesMeta;
}

export type OccurrencesExportFilters = {
  order?: orderType | string;
  page?: number;
  take?: number;
  status?: string;
  initial_date?: string;
  final_date?: string;
  city?: string;
  region?: string;
  search?: string;
  document_number?: string;
  state?: string;
  initial_date_create?: string;
  final_date_create?: string;
  agent_presence?: string;
  circumstance?: string;
  qualification?: string;
  place?: string;
};

export async function exportOccurrences(
  token: string,
  filters: OccurrencesExportFilters
) {
  const params = new URLSearchParams();

  if (filters.order != undefined) {
    params.append('order', filters.order.toString());
  } else {
    params.append('order', 'DESC');
  }

  if (filters.initial_date != undefined && filters.initial_date != '') {
    params.append('initialdate', filters.initial_date);
  }
  if (filters.final_date != undefined && filters.final_date != '') {
    params.append('finaldate', filters.final_date);
  }

  if (
    filters.initial_date_create != undefined &&
    filters.initial_date_create != ''
  ) {
    params.append('initialdate_createdat', filters.initial_date_create);
  }
  if (
    filters.final_date_create != undefined &&
    filters.final_date_create != ''
  ) {
    params.append('finaldate_createdat', filters.final_date_create);
  }

  if (filters.region != undefined) {
    params.append('region', filters.region);
  }
  if (filters.search != undefined) {
    params.append('search', filters.search);
  }
  if (filters.city != undefined) {
    params.append('city', filters.city);
  }
  if (filters.agent_presence != undefined) {
    params.append('agentpresence', filters.agent_presence);
  }
  if (filters.page != undefined) {
    params.append('page', filters.page.toString());
  } else {
    params.append('page', '1');
  }
  if (filters.take != undefined) {
    params.append('take', filters.take.toString());
  } else {
    params.append('take', '50');
  }
  if (filters.status != undefined && filters.status != '') {
    params.append('status', filters.status.toString());
  }
  if (filters.document_number != undefined) {
    params.append('document', filters.document_number);
  }
  if (filters.state != undefined) {
    params.append('state', filters.state);
  }
  if (filters.circumstance != '' && filters.circumstance != undefined) {
    params.append('circumstance', filters.circumstance);
  }
  if (filters.qualification != '' && filters.qualification != undefined) {
    params.append('qualification', filters.qualification);
  }
  if (filters.place != '' && filters.place != undefined) {
    params.append('place', filters.place);
  }

  return api.get('/occurrences/v2/export', {
    headers: {
      Authorization: `Bearer ${token}`
    },
    params,
    responseType: 'blob'
  });
}

export async function getOccurrencesByParams(
  token: string,
  order?: orderType | string,
  page?: number,
  take?: number,
  status?: string,
  initial_date?: string,
  final_date?: string,
  city?: string,
  region?: string,
  search?: string,
  document_number?: string,
  state?: string,
  initial_date_create?: string,
  final_date_create?: string,
  agent_presence?: string,
  circumstance?: string,
  qualification?: string,
  place?: string
) {
  let params = new URLSearchParams();

  if (order != undefined) {
    params.append('order', order.toString());
  } else {
    params.append('order', 'DESC');
  }

  if (initial_date != undefined && initial_date != '') {
    params.append('initialdate', initial_date);
  }
  if (final_date != undefined && final_date != '') {
    params.append('finaldate', final_date);
  }

  if (initial_date_create != undefined && initial_date_create != '') {
    params.append('initialdate_createdat', initial_date_create);
  }
  if (final_date_create != undefined && final_date_create != '') {
    params.append('finaldate_createdat', final_date_create);
  }

  if (region != undefined) {
    params.append('region', region);
  }
  if (search != undefined) {
    params.append('search', search);
  }
  if (city != undefined) {
    params.append('city', city);
  }
  if (agent_presence != undefined) {
    params.append('agentpresence', agent_presence);
  }
  if (page != undefined) {
    params.append('page', page.toString());
  } else {
    params.append('page', '1');
  }
  if (take != undefined) {
    params.append('take', take.toString());
  } else {
    params.append('take', '50');
  }
  if (status != undefined && status != '') {
    params.append('status', status.toString());
  }
  if (document_number != undefined) {
    params.append('document', document_number);
  }
  if (state != undefined) {
    params.append('state', state);
  }
  if (circumstance != '' && circumstance != undefined) {
    params.append('circumstance', circumstance);
  }
  if (qualification != '' && qualification != undefined) {
    params.append('qualification', qualification);
  }
  if (place != '' && place != undefined) {
    params.append('place', place);
  }

  try {
    const resposta = await api.get('/occurrences/v2', {
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: params
    });
    let resp = resposta.data;
    return resp;
  } catch (erro) {
    console.warn('(Ocorrencias) Erro:', erro);
    return null;
  }
}

export async function getOccurrenceChanges(
  token: string,
  page = 1,
  take = 10,
  order: OccurrenceChangesOrder = 'DESC'
): Promise<IOccurrenceChangesResponse | null> {
  const params = new URLSearchParams();

  params.append('page', page.toString());
  params.append('take', take.toString());
  params.append('order', order);

  try {
    const response = await api.get('/occurrences/changes', {
      headers: { Authorization: `Bearer ${token}` },
      params
    });

    return response.data;
  } catch (error) {
    console.warn('(Ocorrencias) Erro ao buscar alteracoes:', error);
    return null;
  }
}

export async function getOccurrenceChangesByOccurrenceId(
  token: string,
  id: string,
  page = 1,
  take = 10,
  order: OccurrenceChangesOrder = 'DESC'
): Promise<IOccurrenceChangesResponse | null> {
  const params = new URLSearchParams();

  params.append('page', page.toString());
  params.append('take', take.toString());
  params.append('order', order);

  try {
    const response = await api.get(`/occurrences/${id}/changes`, {
      headers: { Authorization: `Bearer ${token}` },
      params
    });

    return response.data;
  } catch (error) {
    console.warn(
      '(Ocorrencias) Erro ao buscar alteracoes da ocorrencia:',
      error
    );
    return null;
  }
}
